'use strict';

import ReactDOM from 'react-dom';
import App from 'apps/training-search';

const element = document.getElementById('app');
const algolia = {
	app_id: element.dataset.algoliaAppId,
	key: element.dataset.algoliaKey,
	index: element.dataset.algoliaIndex,
};

ReactDOM.render(<App algolia={ algolia } />, element);
